/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import add_comma from "../lib/add_comma";

// 등록하기 팝업
function ProductSearch(props) {
  const token = localStorage.getItem("token");
  const { login, onAfterProductSearchClick, onHideProductSearchClick, tcidParent} = props;
  const [rows, setRows] = useState([]);
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState(tcidParent);
  const [name, setName] = useState("");

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "gubun", headerName: "구분", width: 130, align: "center" },
    { field: "p_name", headerName: "상품명", width: 200, align: "left" },
    { field: "amount", headerName: "가격", width: 130, align: "center",
    renderCell:(params)=>{
      return add_comma(params.row.amount)
    }
  },     
    { field: "pt_count", headerName: "수량", width: 130, align: "center" },     
    { field: "duration", headerName: "유효기간", width: 130, align: "center",
    renderCell:(params)=>{
      return params.row.d_count+params.row.d_type;
    } },     
  ];

  const onSearchClick = async () => {
    let postData = {
      token: token,
      level: login.level,
      mcd : login.mcd,
      cid: login.cid, 
      tcid : tcid,
      name: name,
    }
    let result = await axios.post(configState.api+"/gympass_admin/search_product", postData);
    if(result.data.success) {
      setRows(result.data.rows);
    }
    else {
      setRows([]);
    }
  };

  // useEffect(()=>{
  //   if(data.cid!=='') {
  //     onSearchClick();
  //   }
  // },[data.cid]);

  return (
    <Box sx={{ m: 2}}>      
      {/* 가맹점 */}
      <Box>
        <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />            
      </Box>

      <Box display="flex" sx={{mt:1}}>
        {/* 이름 */}
        <Box          
        >
          <TextField
            sx={{ width: 200 }}
            name="name"
            label="상품명"
            size="small"            
            autoComplete="off"
            value={name}
            onChange={(e)=>setName(e.target.value)}
          ></TextField>
        </Box>
        
        <Button 
        sx={{ml:1}}
        variant="contained" onClick={onSearchClick} size="small">
          조회
        </Button>
      </Box>

      <DataGrid
        sx={{minHeight:350, mt:1}}
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[5]}
        checkboxSelection={false}
        onRowClick={(params, event)=>{
          // pr(params.id);
          // pr(params.row.mb_name);
          onAfterProductSearchClick({id: params.id, name:params.row.p_name, amount: params.row.amount});  
          onHideProductSearchClick();        
        }}        
      />
    </Box>
  );
}

export default ProductSearch;
